import { gql } from '@apollo/client'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'
import { PlanetLiteFragment } from '@src/graphql/fragment/planet'

export default gql`
  query GetPlanets(
    $filterInput: GetPlanetsFilterInput!
    $pagingInput: PagingInput
    $sortInput: PlanetSortInput!
  ) {
    getPlanets(
      filterInput: $filterInput
      pagingInput: $pagingInput
      sortInput: $sortInput
    ) {
      edges {
        cursor
        node {
          ...PlanetLite
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${PlanetLiteFragment}
  ${PageInfoFragment}
`
